const debug = process.env.NODE_ENV !== "production";

import "babel-polyfill"
import * as types from "./mutation-types";

import Vue from "vue"
import Vuex from "vuex"
import axios from "axios";

import sessionNotes from "./sessionNotes";
import currentUser from "../../store/currentUser";

import Raven from 'raven-js';

Vue.use(Vuex);

const state = {
    brewId: window.currentItem.brewId,
    ownerId: window.currentItem.ownerId,
    brew: window.currentItem.brew,
    urls: window.currentItem.urls,
    device: window.currentItem.device,
    isActive: window.currentItem.isActive,
    comments: [],
    stats: window.currentItem.latestStats,
    showRecipe: true
    //isOwner: false
    //isMetric: currentUser.display.units === 1,
    //isCelcius: currentUser.display.temp === 1,
    //isLoggedIn: currentUser.isLoggedIn
}

const getters = {
    isOwner: (state) => {
        //console.log(JSON.stringify({a:currentUser.state.isLoggedIn, b:state.ownerId , c:currentUser.state.userId}));
        return currentUser.state.isLoggedIn && state.ownerId === currentUser.state.userId;
    }
}

const mutations = {
    SET_BREW: (state, value) => {
        state.brew = value;
    },
    SET_COMMENTS: (state, value) => {
        state.comments = value;
    },
    ADD_COMMENT: (state, comment) => {
        state.comments.push(comment);
    },
    SET_STATS: (state, stats) => {
        state.stats = stats;
    },
    SET_DEVICE: (state, device) => {
        state.device = device;
    },
    SET_SHOW_RECIPE: (state, showRecipe) => {
        state.showRecipe = showRecipe;
    }
}

const actions = {
    getBrew: ({ commit }) => {
        commit('SET_BREW', window.brew);
    },

    async getComments({ commit, state }) {

        return await axios.get(`/api/brews/${state.brewId}/sessions/latest/comments`)
            .then((response) => {
                commit('SET_COMMENTS', response.data);
            })
            .catch((err) => {
                console.log(err);
                Raven.captureException(err);
                Raven.showReportDialog();
            });
    },

    async addComment({ commit, state }, comment) {
        return await axios.post(`/api/brews/${state.brewId}/sessions/comments`, { brewId: state.brewId, text: comment })
            .then(function (response) {
                commit('ADD_COMMENT', response.data);
            })
            .catch((err) => {
                console.log(err);
                Raven.captureException(err);
                Raven.showReportDialog();
            });
    },

    async getLatestStats({ commit, state }) {
        return await axios.get(`/api/brews/${state.brewId}/sessions/latest/stats`)
            .then((response) => {
                commit('SET_STATS', response.data);
            })
            .catch((err) => {
                console.log(err);
                Raven.captureException(err);
                Raven.showReportDialog();
            });
    }
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {
        currentUser,
        sessionNotes
    },
    strict: debug
})




//import axios from 'axios'

//var store = {
//    debug: false,
//    state: {
//        brewId: null
//    },
//    getReadings() {
//        //this.debug && console.log('getReadings triggered')
//        return axios.get(`/api/users/brews/${self.brewId}/readings`, {
//            params: {
//                after: after,
//                limit: this.state.pagination.count
//            }
//        })
//    }
//}

//export default store


//////////////////
// WEBPACK FOOTER
// ./src/sections/brew/store/index.js
// module id = 768
// module chunks = 6